import {
  displayMixins,
  fontFamilyMixin,
  headingMixins,
  paragraphMixins
} from "./chunk-6FXAQBW6.mjs";
import {
  React,
  __name,
  init_react_import
} from "./chunk-65BGW52G.mjs";

// components/Text/Text.tsx
init_react_import();
import styled from "styled-components";
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
__name(_extends, "_extends");
var StyledSpan = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement("span", _extends({}, props), props.children), "StyledSpan");
var Span = styled(StyledSpan)`
  color: ${({ color = "primary", theme }) => color == null ? "inherit" : theme.color.text[color]};
  ${fontFamilyMixin};
`;
var Display = styled(Span).attrs(() => ({
  as: "h1"
}))`
  ${({ size }) => displayMixins[size]}
`;
var HeadingComponent = styled(Span)`
  ${({ size }) => headingMixins[size]}
`;
var Heading = /* @__PURE__ */ __name(({ as, size, ...props }) => {
  return /* @__PURE__ */ React.createElement(HeadingComponent, _extends({
    as: as || "h3",
    size
  }, props));
}, "Heading");
var Paragraph = styled(Span).attrs(({ as = "p" }) => ({
  as
}))`
  ${({ size = "md", weight = "normal" }) => {
  if (weight !== "normal") {
    if ([
      "md",
      "lg"
    ].includes(size)) {
      return paragraphMixins[size + weight.charAt(0).toUpperCase() + weight.slice(1)];
    } else {
      console.error(`Weight '${weight}' does not exist for size '${size}'.`);
    }
  }
  return paragraphMixins[size];
}}
  /* Unlike the other text components, Paragraph defaults to the secondary text color. */
  color: ${({ color = "secondary", theme }) => theme.color.text[color]};
`;
var Label = styled(Paragraph).attrs({
  as: "label"
})`
  color: ${({ color = "primary", theme }) => theme.color.text[color]};
`;

export {
  Span,
  Display,
  Heading,
  Paragraph,
  Label
};
//# sourceMappingURL=chunk-PZCCRLSA.mjs.map